<template>
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog" :id="`${modalId}`" :aria-labelledby="`${modalId}`" aria-hidden="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content p-top-10 p-bottom-10">
                <div class="modal-header new-design">
                    <h5 class="modal-title d-inline">Confirm attendance</h5>
                    <svg class="close-icon clickable float-right " data-dismiss="modal" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z" fill="#2E4051"/>
                    </svg>
                </div>

                <div class="modal-body">
                    <div v-for="(visit,visit_index) of visitsForConfirmation" >
                        <div  v-if="isUniqueDisplay(visit.contractor_id, visit_index)"  class="row mobile-m-bottom-0 mobile-p-bottom-0" >
                            <div class="col-md-6 p-right-0 p-left-0" style=" display: flex; align-items: center;">
                                <div class=" col-md-2 no-padding-right mob  no-padding-left ">
                                    <img v-if="visit.avatar && type   &&  type !='customer'" class="img-responsive"
                                         style=" border-radius: 50%;  width: 50px;  height: 50px; "
                                         :src="s3Path +visit.avatar"/>
                                    <img v-else class="img-responsive"
                                         style="  border-radius: 50%; width: 50px;  height: 50px; "
                                         src="/pic/contractor_pic1.png"/>
                                </div>

                                <div v-if="  type &&  type =='customer' " class="col-md-10 no-padding-left "  >
                                    {{ infoForConfirmation.name }}
                                </div>
                                <div v-else class="col-md-10 no-padding-left "  >
                                    {{ visit.display_name }}
                                </div>
                            </div>
                        </div>
                        <div class=" item_style row m-top-20 mobile-m-top-0" :style="visit.style_confirmed ?visit.style_confirmed:''"
                             :id="signature_ReminderAdd('date_add_border_to_selected_section_',visit)"  >
                                <div class="col-md-12 p-left-0 p-right-0" v-if="!isMobile">
                                    <div class="col-md-1 checkbox-position-style">
                                        <input type="checkbox" :disabled="visit.disabled" :id="signature_ReminderAdd('input_checkbox_',visit)" @click="add_border_to_selected_section( visit)" :value="visit.multiple_day_id">
                                    </div>
                                    <div class="col-md-10 p-left-0">
                                        <div class="col-md-12 col-xs-12 p-right-0 p-left-0">
                                            <div class="col-md-5 col-xs-5 labels-font font-family-Roboto time_data ">
                                                {{ moment_DateFormatted (visit.booking_start ) }} -{{ moment_DateFormatted (visit.booking_end ) }}
                                            </div>
                                            <div class="col-md-7 col-xs-7">
                                                <span class="float-right serv_name " >  {{ visit.service_name }}    </span>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-xs-12 p-right-0 p-left-0">
                                            <div class="col-md-10 col-xs-6 labels-font font-family-Roboto time_data ">
                                            {{ startDateFormatted(visit.booking_end )}}
                                            </div>
                                            <div class="col-md-2 col-xs-6">
                                                <span :id="signature_ReminderAdd('visit_status_title_',visit)" style="color: rgb(255, 147, 47);" :class="`visit_status_data font-bold float-right ${visit.Confirm_attendance_status_btn_class}`">
                                              {{ visit.Confirm_attendance_status_btn_title }}
                                                  </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="visit.show_unconfirm_button" class="col-md-1 p-left-0 p-right-0" style=" text-align: center; padding-top: 9px;">
                                        <div class="btn-group pair_btn_new_uniq left-12" v-if="reminder_data.last_inserted_reminder_id && (reminder_data.last_inserted_visit_id == visit.id)  || 1==1">

                                            <button data-toggle="dropdown" data-too="tooltip" data-placement="bottom"
                                                    aria-haspopup="true" aria-expanded="false"
                                                    class="btn btn-default dropdown-toggle  create-btn FontSize">
                                                <i class="fa fa-ellipsis-v " style="color:rgba(138, 138, 138,1);font-size: 18px;"></i>
                                            </button>

                                            <ul class="dropdown-menu pair_of_all_li w_und_767 mobile-right-8" id="pair_of_all_li" style="right: 0; left: auto;">
                                                <li>
                                                    <a :id="signature_ReminderAdd('img',visit)"
                                                       @click="unconfirmed_attendance_for_this_visit(visit)">
                                                        <span></span>
                                                        <span>Remove Confirmation</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <!--Mobile View-->
                                <div class="col-xs-12 p-left-0 p-right-0 mobile-m-bottom-0" v-if="isMobile">
                                    <div class="col-xs-12 p-left-0 mobile-m-bottom-0">
                                        <div class="col-xs-12 p-right-0 p-left-0 mobile-m-bottom-0">
                                            <div class="col-xs-11 labels-font font-family-Roboto time_data mobile-m-bottom-0">
                                                {{ moment_DateFormatted (visit.booking_start ) }} -{{ moment_DateFormatted (visit.booking_end ) }}
                                            </div>
                                            <div class="col-xs-1 checkbox-position-style mobile-m-bottom-0">
                                                <input type="checkbox" :disabled="visit.disabled" :id="signature_ReminderAdd('input_checkbox_',visit)" @click="add_border_to_selected_section( visit)" :value="visit.multiple_day_id">
                                            </div>
                                            <div class="col-xs-12 labels-font font-family-Roboto time_data mobile-m-bottom-0">
                                                {{ startDateFormatted(visit.booking_end )}}
                                            </div>
                                        </div>
                                        <div class="col-xs-12 p-right-0 p-left-0 mobile-m-bottom-0">
                                            <div class="col-xs-12 mobile-m-bottom-0">
                                                <span class="serv_name mobile-m-bottom-0">  {{ visit.service_name }}    </span>
                                            </div>
                                            <div class="col-xs-11 mobile-m-bottom-0">
                                                <span :id="signature_ReminderAdd('visit_status_title_',visit)" style="color: rgb(255, 147, 47);" :class="`visit_status_data font-bold ${visit.Confirm_attendance_status_btn_class}`">
                                              {{ visit.Confirm_attendance_status_btn_title }}
                                                  </span>
                                            </div>
                                            <div v-show="visit.show_unconfirm_button" class="col-xs-1 p-left-0 p-right-0 mobile-m-bottom-0" style=" text-align: center; padding-left: 4px !important;">
                                                <div class="btn-group pair_btn_new_uniq left-12 mobile-m-bottom-0 mobile-bottom-8" v-if="reminder_data.last_inserted_reminder_id && (reminder_data.last_inserted_visit_id == visit.id)  || 1==1">

                                                    <button data-toggle="dropdown" data-too="tooltip" data-placement="bottom"
                                                            aria-haspopup="true" aria-expanded="false"
                                                            class="btn btn-default dropdown-toggle  create-btn FontSize">
                                                        <i class="fa fa-ellipsis-v " style="color:rgba(138, 138, 138,1);font-size: 18px;"></i>
                                                    </button>

                                                    <ul class="dropdown-menu pair_of_all_li w_und_767 mobile-right-8" id="pair_of_all_li" style="right: 0; left: auto;">
                                                        <li>
                                                            <a :id="signature_ReminderAdd('img',visit)"
                                                               @click="unconfirmed_attendance_for_this_visit(visit)">
                                                                <span></span>
                                                                <span>Remove Confirmation</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <hr/>
                    </div>

                </div>

                <div class="modal-footer new-design">
                    <div class="row" style="padding: 0px 20px;">
                        <div class="col-md-6 col-xs-12">
                            <a type="button" data-dismiss="modal" aria-label="Close" class="btn btn-default new-design float-left btn-mobile-width navy-color mobile-width-100"
                               href="javascript:void(0)">Cancel </a>
                        </div>
                        <div class="col-md-6 col-xs-12">
                             <a  type="button" class=" click_load_data  btn btn-primary new-design float-right btn-mobile-width mr-2 ml-2 mobile-width-100" href="javascript:void(0)"
                                 @click="call_api_bookingReminderAdd()">   Confirm  </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import moment from "moment/moment";
import Vue from 'vue';
import alert from "bootstrap/js/src/alert";

export default {
    name: "rejectAcceptAdminServices",
    props: {
        modalId:null,
        s3Path:null,
        visits: null,
        bookingId: null,
    },
    data() {
        return {
            contractorId:null,
            infoForConfirmation:null,
            visit_status_val:'',
            all_selected_visit:[],
            reminder_data: [],
            type: null,
            /** visitsForConfirmation ?? the list  of all visits but filter by contractor ID or show all visits   **/
            visitsForConfirmation: this.visits,
        }
    },
    computed: {
        isMobile() {
            return this.getWidth() <= 768;
        },
    },
    methods: {
        isUniqueDisplay(contractor_id, currentIndex) {

            if ( this.type &&  this.type =='customer' && currentIndex )
            {  return  currentIndex ===0;  }
            else { return this.visitsForConfirmation.findIndex((visit, index) => visit.contractor_id === contractor_id && index < currentIndex) === -1; }
        },
      check_Reminder(type) {
           var  vm=this;

            let url = `/booking/reminder/getByBookingIdAndVisitId/${this.bookingId}/${type}/?booking_id=${this.bookingId}?type=${type}`;

            axios.get(url).then(function (response) {

                vm.visitsForConfirmation = vm.visitsForConfirmation.map(vi => {
                    // Find a matching attribute from service_attributes
                        // If found, copy all properties except unit_price from the matching attribute
                        return {
                            ...vi,
                            style_confirmed: null,
                            disabled: false,
                            show_unconfirm_button: false,
                            Confirm_attendance_status_btn_title: 'Unconfirmed',
                            Confirm_attendance_status_btn_class: 'unconfirm-color',
                            reminder_id: null,
                        };

                });
                     response.data.forEach(function(currentElement, index) {

                         let selectedVisitIndex = vm.visitsForConfirmation.findIndex(vis => vis.multiple_day_id === currentElement.visit_id);
                         if (selectedVisitIndex !== -1) {
                             Vue.set(vm.visitsForConfirmation[selectedVisitIndex], 'reminder_id',currentElement.id);
                         vm.changeToConfirmed(selectedVisitIndex);
                         }
                    })



                return
            });


        },
      unconfirmed_attendance_for_this_visit(visit) {
          var vm=this;
         var reminder_data_val;
         var img_data_section = $('#'+visit.reminder_id+' img');
        img_data_section.attr('src', '/pic/loading-4.gif'); // Replace with your new image source
            let url = `/booking/reminder/delete/${visit.booking_id}/${visit.reminder_id}/?booking_id=${visit.booking_id}&id=${visit.reminder_id}`;

            axios.post(url).then(function (response) {
                if (response.data.id ) {
                    let selectedVisitIndex = vm.visitsForConfirmation.findIndex(vis =>vis.multiple_day_id === visit.multiple_day_id);

                    if (selectedVisitIndex !== -1) {
                    Vue.set(vm.visitsForConfirmation[selectedVisitIndex], 'reminder_id',null);
                        vm.changeToUNConfirmed(selectedVisitIndex);
                    }
                    reminder_data_val={ booking_id : visit.booking_id ,id:visit.multiple_day_id};

                    var index = vm.all_selected_visit.indexOf(reminder_data_val);
                    if (index > -1) {
                        vm.all_selected_visit.splice(index, 1); // Remove the item at the found index
                    }

                  img_data_section.attr('src', '/pic/remove.png'); // Replace with your new image source

                    vm.$nextTick(function(){

                        visit.user_type=vm.type;
                      //  EventBus.$emit('titleConfirmationChange', currentElement );
                        EventBus.$emit('titleConfirmationChange', visit );
                    })

                }
                return
            });
        },
      signature_ReminderAdd( element, visit_data) {
           return element+ visit_data.booking_id +'_' + visit_data.multiple_day_id +'_' + this.modalId;
           },
      call_api_bookingReminderAdd( ) {
             var vm=this;

           if(this.all_selected_visit.length ){
            $(".click_load_data").html('<img src="/pic/loading-4.gif">');

            this.all_selected_visit.forEach(function(currentElement, index) {
                let url
                if (vm.type == 'customer'){
                      url = `/booking/reminder/add/${currentElement.booking_id}?booking_id=${currentElement.booking_id}&visit=${currentElement.multiple_day_id}`;
                }else {
                      url = `/booking/reminder/add/${currentElement.booking_id}?booking_id=${currentElement.booking_id}&visit=${currentElement.multiple_day_id}&fieldworker_id=${currentElement.contractor_id}`;

                }
              axios.post(url).then(function (response) {
                if (response.data.id ) {

                    let selectedVisitIndex = vm.visitsForConfirmation.findIndex(vis =>vis.multiple_day_id == response.data.last_inserted_visit_id);
                    if (selectedVisitIndex !== -1) {
                        Vue.set(vm.visitsForConfirmation[selectedVisitIndex], 'reminder_id',response.data.last_inserted_reminder_id);
                        vm.changeToConfirmed(selectedVisitIndex);
                    }
                        vm.$nextTick(function(){
                            currentElement.user_type=vm.type;

                            EventBus.$emit('titleConfirmationChange', currentElement  );
                          })

                        vm.all_selected_visit = []
                        //$.notify(response.data.msg, 'success');
                        $(".click_load_data").html('Confirm');

                }
                return
              });
            })


          }

        },
      changeToConfirmed(selectedVisitIndex){
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'style_confirmed', {
                border: '1px solid #19875473',
                background: '#1987542b'
            });
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'disabled', true);
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'show_unconfirm_button',true);
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'Confirm_attendance_status_btn_title', ' Confirmed');
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'Confirm_attendance_status_btn_class', 'confirm-color');
        },
      changeToUNConfirmed(selectedVisitIndex){
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'style_confirmed', null);
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'disabled', false);
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'show_unconfirm_button',false);
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'Confirm_attendance_status_btn_title', ' Unconfirmed');
            Vue.set(this.visitsForConfirmation[selectedVisitIndex], 'Confirm_attendance_status_btn_class', 'unconfirm-color');
        },
      add_border_to_selected_section(visit_data ) {

            var date_add_border_to_selected_section_data= this.signature_ReminderAdd('date_add_border_to_selected_section_',visit_data)
            var input_checkbox__data= this.signature_ReminderAdd('input_checkbox_',visit_data)
            var input_checkbox =  $('#'+input_checkbox__data);
            var date_add_border_to_selected_section = $('#'+date_add_border_to_selected_section_data);
          if (input_checkbox.is(':checked')) {
            this.all_selected_visit.push(visit_data);
            date_add_border_to_selected_section.css('border', '1px solid #0d6efd');
          } else {
            var index = this.all_selected_visit.indexOf(visit_data);
            if (index > -1) {
              this.all_selected_visit.splice(index, 1); // Remove the item at the found index
            }
            date_add_border_to_selected_section.css('border', '0px');
          }

        },
      startDateFormatted(startDate) {
            return moment(startDate).format("DD MMM YYYY")
        },
      moment_DateFormatted(startDate) {
            return moment(startDate).format( 'hh:mm A')
        },
      getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
    },
    mounted() {

        EventBus.$on('infoForConfirmation', infoForConfirmation => {
             var vm =this;

            if (infoForConfirmation && this.visitsForConfirmation &&  this.visitsForConfirmation[0] && infoForConfirmation['item_id'] ==this.visitsForConfirmation[0].booking_id){
                this.type=infoForConfirmation['item_type'];
                this.infoForConfirmation=infoForConfirmation;
                if (infoForConfirmation['item_type']==='Technician'){
                    this.contractorId=infoForConfirmation['id'];
                     this.visitsForConfirmation = this.visits.filter(   item => parseInt(item.contractor_id) == parseInt(vm.contractorId) ).sort((a, b) => a.contractor_id - b.contractor_id);
                }else{
                    this.visitsForConfirmation = this.visits.sort((a, b) => a.contractor_id - b.contractor_id);

                }
            }else {
                this.visitsForConfirmation = this.visits.sort((a, b) => a.contractor_id - b.contractor_id);
            }
            if  (!this.type) {
                this.type='Technician';
            }
            this.check_Reminder(this.type)
        })
    }
}
</script>
<style scoped>
.confirm-color{
     color:#04AA6D!important;
}
.unconfirm-color{
    color: rgb(255, 147, 47);
}
.confirm-color{
    color:#FF932F;
}
.item_style {
     //background: #ededed;
    border-radius: 10px;
    padding: 12px;
    }
.checkbox-position-style{
    padding-right: 0px;
    width: 4% !important;
    position: relative;
    top: 6px;
}
.time_data{
    color: var(--Navy, #2E4051);
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 100% */
}
.serv_name{color: var(--Navy, #2E4051);
/* Body/Left/Regular/16 */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */}
.visit_status_data{    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;}
.modal-header.new-design {
    border-bottom: unset;
}

.has-error .form-control {
    border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #2E4051;
    display: inline;
}

.modal-footer.new-design {
    border-top: unset;
    display: block !important;
}

.close-icon {
    float: right;
}

.clickable {
    cursor: pointer;
}

.error-label {
    top: 8px;
    position: relative;
}

.btn.new-design {
    border-radius: 8px;
    padding: 12px 16px;
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
}
.navy-color {
    color: #2E4051 !important;
}
.btn-primary.new-design {
    background: #2E4051 !important;
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.btn.new-design {
    margin-bottom: unset;
}
.modal-body {
    padding-bottom: 0px !important;
}
.modal-footer {
    padding-top: 0px !important;
}
@media (max-width: 768px) {
    .mobile-width-100 {
        width: 100% !important;
    }
    .mobile-m-top-0 {
        margin-top: 0px !important;
    }
    .mobile-m-bottom-0 {
        margin-bottom: 0px;
    }
    .mobile-p-bottom-0 {
        padding-bottom: 0px;
    }
    .mobile-bottom-8 {
        bottom: 8px;
    }
    .modal-body {
        padding: 0px 30px 30px 30px !important;
    }
}
</style>